module.exports = __webpack_public_path__ + "img/research-intro-h5.67d2be2d.png";